import { Component, Inject, Input, OnInit } from '@angular/core';
import { SubdimensionModel } from 'src/app/model/FaseAnual.model';
import { FaseAnualComponent } from '../fase-anual.component';

@Component({
  selector: 'app-subdimension-anual',
  templateUrl: './subdimension-anual.component.html',
  styleUrls: ['./subdimension-anual.component.css']
})
export class SubdimensionAnualComponent implements OnInit {

  @Input() indice : number;
  @Input() estadoData : number;
  @Input() areaNumber : number;
  @Input() subdimensionData : SubdimensionModel;
  @Input() readonly : boolean;

  constructor(
    @Inject(FaseAnualComponent) private parentFE: FaseAnualComponent,
  ) { }

  ngOnInit(): void {  
  }

  change(){
    this.parentFE.cambios = true;
  }
}
